import React from "react";
import visionImage from "../../images/hero/vision.png";

const Vision: React.FC = () => {
  const visionPoints = [
    {
      title: "Technical Excellence",
      icon: (
        <svg viewBox="0 0 48 48" aria-hidden="true">
          <circle cx="24" cy="24" r="15" />
          <circle cx="24" cy="24" r="8" />
          <path d="M24 24l13-13" />
          <path d="M32 11h6v6" />
        </svg>
      ),
    },
    {
      title: "Trusted Partnerships",
      icon: (
        <svg viewBox="0 0 48 48" aria-hidden="true">
          <path d="M8 19l9-6 7 5 7-5 9 6" />
          <path d="M13 21l9 9c1.2 1.2 3.2 1.2 4.4 0l9-9" />
          <path d="M8 19v11l7 6" />
          <path d="M40 19v11l-7 6" />
        </svg>
      ),
    },
    {
      title: "Innovation Driven",
      icon: (
        <svg viewBox="0 0 48 48" aria-hidden="true">
          <path d="M16 26c-2-2-3-5-3-8a11 11 0 0 1 22 0c0 3-1 6-3 8-2 2-3 4-3 7H19c0-3-1-5-3-7Z" />
          <path d="M19 37h10" />
          <path d="M21 41h6" />
          <path d="M24 2v5M7 18h5M36 18h5M10 7l4 4M38 7l-4 4" />
        </svg>
      ),
    },
    {
      title: "Creating Lasting Value",
      icon: (
        <svg viewBox="0 0 48 48" aria-hidden="true">
          <circle cx="24" cy="16" r="6" />
          <circle cx="11" cy="21" r="4" />
          <circle cx="37" cy="21" r="4" />
          <path d="M14 39v-4c0-6 4-10 10-10s10 4 10 10v4" />
          <path d="M3 39v-3c0-5 3-8 8-8 2 0 4 1 5 2" />
          <path d="M45 39v-3c0-5-3-8-8-8-2 0-4 1-5 2" />
        </svg>
      ),
    },
  ];

  return (
    <>
      <style>{`
        .vision-section {
          position: relative;
          overflow: hidden;
          padding: 120px 0;
          background:
            radial-gradient(
              circle at 88% 48%,
              rgba(44, 50, 254, 0.22),
              transparent 34%
            ),
            radial-gradient(
              circle at 12% 88%,
              rgba(88, 1, 249, 0.08),
              transparent 30%
            ),
            linear-gradient(
              135deg,
              #02030d 0%,
              #050818 52%,
              #03040f 100%
            );
        }

        .vision-section::before {
          content: "";
          position: absolute;
          left: -130px;
          bottom: -170px;
          width: 430px;
          height: 430px;
          border-radius: 50%;
          border: 1px solid rgba(88, 1, 249, 0.12);
          pointer-events: none;
        }

        .vision-section::after {
          content: "";
          position: absolute;
          right: 4%;
          bottom: 8%;
          width: 150px;
          height: 95px;
          opacity: 0.32;
          background-image: radial-gradient(
            circle,
            #B794FF 2px,
            transparent 2px
          );
          background-size: 18px 18px;
          pointer-events: none;
        }

        .vision-container {
          position: relative;
          z-index: 2;
          width: min(1320px, calc(100% - 40px));
          margin: 0 auto;
        }

        .vision-row {
          display: grid;
          grid-template-columns: minmax(0, 1.08fr) minmax(420px, 0.92fr);
          align-items: center;
          gap: 80px;
        }

        .vision-content {
          position: relative;
          z-index: 2;
        }

        .vision-subtitle {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 22px;
          color: #B794FF;
          font-size: 15px;
          line-height: 1;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }

        .vision-subtitle::before {
          content: "";
          width: 34px;
          height: 2px;
          border-radius: 10px;
          background: linear-gradient(
            90deg,
            #2c32fe 0%,
            #00a4af 50%,
            #B794FF 100%
          );
        }

        .vision-heading {
          max-width: 740px;
          margin: 0 0 28px;
          color: #ffffff;
          font-size: clamp(42px, 5vw, 72px);
          line-height: 1.08;
          font-weight: 700;
          letter-spacing: -0.04em;
        }

        .vision-heading span {
          background: linear-gradient(
            52deg,
            #5459ff 0%,
            #00b8c6 50%,
            #B794FF 100%
          );
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          color: transparent;
        }

        .vision-divider {
          position: relative;
          width: 260px;
          height: 3px;
          margin-bottom: 30px;
          overflow: hidden;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0.12);
        }

        .vision-divider::before {
          content: "";
          position: absolute;
          inset: 0 auto 0 0;
          width: 88px;
          border-radius: inherit;
          background: linear-gradient(
            90deg,
            #2c32fe 0%,
            #00a4af 50%,
            #B794FF 100%
          );
        }

        .vision-description {
          max-width: 760px;
          margin: 0;
          color: rgba(255, 255, 255, 0.72);
          font-size: 18px;
          line-height: 1.8;
          font-weight: 400;
        }

        .vision-features {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          margin-top: 48px;
        }

        .vision-feature {
          position: relative;
          min-width: 0;
          padding: 0 22px;
          text-align: center;
        }

        .vision-feature:first-child {
          padding-left: 0;
        }

        .vision-feature:last-child {
          padding-right: 0;
        }

        .vision-feature:not(:last-child)::after {
          content: "";
          position: absolute;
          top: 7px;
          right: 0;
          width: 1px;
          height: 92px;
          background: rgba(255, 255, 255, 0.12);
        }

        .vision-feature-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 74px;
          height: 74px;
          margin: 0 auto 17px;
          border: 1px solid rgba(255, 255, 255, 0.14);
          border-radius: 50%;
          background:
            linear-gradient(
              145deg,
              rgba(255, 255, 255, 0.08),
              rgba(255, 255, 255, 0.02)
            ),
            #11121d;
          box-shadow:
            0 16px 35px rgba(0, 0, 0, 0.28),
            inset 0 1px 0 rgba(255, 255, 255, 0.06);
          transition:
            transform 0.3s ease,
            border-color 0.3s ease,
            box-shadow 0.3s ease;
        }

        .vision-feature:hover .vision-feature-icon {
          transform: translateY(-5px);
          border-color: rgba(88, 1, 249, 0.45);
          box-shadow:
            0 20px 40px rgba(0, 0, 0, 0.34),
            0 0 25px rgba(88, 1, 249, 0.08);
        }

        .vision-feature-icon svg {
          width: 36px;
          height: 36px;
          fill: none;
          stroke: #B794FF;
          stroke-width: 2;
          stroke-linecap: round;
          stroke-linejoin: round;
        }

        .vision-feature-title {
          margin: 0;
          color: #ffffff;
          font-size: 15px;
          line-height: 1.45;
          font-weight: 600;
        }

        .vision-visual {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 580px;
        }

        .vision-circle-main {
          position: relative;
          width: min(100%, 530px);
          aspect-ratio: 1;
          padding: 17px;
          border: 16px solid #2c32fe;
          border-radius: 50%;
          background:
            linear-gradient(
              145deg,
              rgba(255, 255, 255, 0.06),
              rgba(255, 255, 255, 0.01)
            ),
            #11121d;
          box-shadow:
            0 34px 75px rgba(0, 0, 0, 0.45),
            0 0 65px rgba(44, 50, 254, 0.17);
        }

        .vision-circle-main::before,
        .vision-circle-main::after {
          content: "";
          position: absolute;
          border-radius: 50%;
          pointer-events: none;
        }

        .vision-circle-main::before {
          inset: -55px;
          border: 1px solid rgba(88, 1, 249, 0.17);
        }

        .vision-circle-main::after {
          inset: -88px;
          border: 25px solid rgba(44, 50, 254, 0.08);
        }

        .vision-image-wrap {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
          border: 5px solid rgba(255, 255, 255, 0.75);
          border-radius: 50%;
          background:
            radial-gradient(circle at 50% 45%, #0b7cff, #031a3d 72%);
        }

        .vision-image-wrap::after {
          content: "";
          position: absolute;
          inset: 0;
          background: radial-gradient(
            circle,
            transparent 35%,
            rgba(0, 28, 73, 0.34) 100%
          );
          pointer-events: none;
        }

        .vision-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transform: scale(1.08);
        }

        .vision-orbit-dot {
          position: absolute;
          z-index: 3;
          width: 15px;
          height: 15px;
          border: 4px solid #050818;
          border-radius: 50%;
          background: #B794FF;
          box-shadow:
            0 5px 15px rgba(88, 1, 249, 0.28),
            0 0 18px rgba(88, 1, 249, 0.22);
        }

        .vision-orbit-dot.dot-one {
          top: 18%;
          left: -58px;
        }

        .vision-orbit-dot.dot-two {
          right: -54px;
          bottom: 20%;
        }

        .vision-orbit-dot.dot-three {
          left: 4%;
          bottom: -43px;
          width: 10px;
          height: 10px;
          border-width: 2px;
        }

        .vision-arc {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 112%;
          height: 112%;
          border: 2px solid rgba(88, 1, 249, 0.14);
          border-right-color: transparent;
          border-bottom-color: transparent;
          border-radius: 50%;
          transform: translate(-50%, -50%) rotate(20deg);
          pointer-events: none;
        }

        @media (max-width: 1199px) {
          .vision-section {
            padding: 100px 0;
          }

          .vision-row {
            grid-template-columns: minmax(0, 1fr) 430px;
            gap: 45px;
          }

          .vision-description {
            font-size: 17px;
          }

          .vision-features {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 30px 0;
          }

          .vision-feature:nth-child(2)::after {
            display: none;
          }

          .vision-visual {
            min-height: 490px;
          }

          .vision-circle-main {
            max-width: 420px;
          }
        }

        @media (max-width: 991px) {
          .vision-section {
            padding: 85px 0;
          }

          .vision-row {
            grid-template-columns: 1fr;
            gap: 70px;
          }

          .vision-content {
            text-align: center;
          }

          .vision-subtitle {
            justify-content: center;
          }

          .vision-heading,
          .vision-description {
            margin-left: auto;
            margin-right: auto;
          }

          .vision-divider {
            margin-left: auto;
            margin-right: auto;
          }

          .vision-visual {
            min-height: auto;
          }

          .vision-circle-main {
            width: min(80vw, 500px);
          }
        }

        @media (max-width: 767px) {
          .vision-section {
            padding: 70px 0;
          }

          .vision-container {
            width: min(100% - 30px, 1320px);
          }

          .vision-row {
            gap: 55px;
          }

          .vision-heading {
            font-size: 39px;
          }

          .vision-description {
            font-size: 16px;
            line-height: 1.75;
          }

          .vision-features {
            gap: 30px 0;
            margin-top: 38px;
          }

          .vision-feature {
            padding: 0 14px;
          }

          .vision-feature:nth-child(2n)::after {
            display: none;
          }

          .vision-feature-icon {
            width: 66px;
            height: 66px;
          }

          .vision-feature:hover .vision-feature-icon {
          transform: translateY(-5px);
          border-color: rgba(88, 1, 249, 0.45);
          box-shadow:
            0 20px 40px rgba(0, 0, 0, 0.34),
            0 0 25px rgba(88, 1, 249, 0.08);
        }

        .vision-feature-icon svg {
            width: 31px;
            height: 31px;
          }

          .vision-circle-main {
            width: min(82vw, 430px);
            padding: 10px;
            border-width: 10px;
          }

          .vision-circle-main::before {
            inset: -28px;
          }

          .vision-circle-main::after {
            inset: -48px;
            border-width: 14px;
          }

          .vision-orbit-dot.dot-one {
            left: -30px;
          }

          .vision-orbit-dot.dot-two {
            right: -28px;
          }
        }

        @media (max-width: 480px) {
          .vision-section {
            padding: 60px 0;
          }

          .vision-heading {
            font-size: 33px;
          }

          .vision-divider {
            width: 190px;
          }

          .vision-features {
            grid-template-columns: 1fr 1fr;
          }

          .vision-feature {
            padding: 0 9px;
          }

          .vision-feature-title {
            font-size: 13px;
          }

          .vision-feature-icon {
            width: 58px;
            height: 58px;
          }

          .vision-feature:hover .vision-feature-icon {
          transform: translateY(-5px);
          border-color: rgba(88, 1, 249, 0.45);
          box-shadow:
            0 20px 40px rgba(0, 0, 0, 0.34),
            0 0 25px rgba(88, 1, 249, 0.08);
        }

        .vision-feature-icon svg {
            width: 27px;
            height: 27px;
          }

          .vision-feature:not(:last-child)::after {
            height: 78px;
          }
        }
        /* Align with the wider About-page sections and soften image framing. */
        .vision-container { width: auto; margin: 0 4.4vw; }
        .vision-row { grid-template-columns: minmax(0,1fr) minmax(0,1fr); gap: clamp(40px,6vw,120px); }
        .vision-heading { max-width: 900px; }
        .vision-description { max-width: 850px; }
        .vision-circle-main { border-width: 4px; border-color: rgba(140,116,255,.6); }
        .vision-image-wrap { border-width: 2px; border-color: rgba(207,218,255,.45); }
        .vision-circle-main::after { border-width: 10px; border-color: rgba(100,85,220,.045); }
        .vision-feature-title { font-size: clamp(15px,1vw,19px); color: #e8eaf8; line-height: 1.4; font-weight: 500; }
        .vision-feature-icon { color: #bfabff; border-color: rgba(167,140,255,.3); }
        @media(max-width:991px) { .vision-row { grid-template-columns: 1fr; } }
        @media(max-width:767px) {
          .vision-container { width: auto; margin: 0 22px; }
          .vision-circle-main { border-width: 3px; }
          .vision-feature-title { font-size: 15px; }
        }
      `}</style>

      <section className="vision-section">
        <div className="vision-container">
          <div className="vision-row">
            <div className="vision-content">
              <span className="vision-subtitle">Our Vision</span>

              <h2 className="vision-heading">
                Shaping the Future of{" "}
                <span>Silicon Innovation</span>
              </h2>

              <div className="vision-divider" />

              <p className="vision-description xb-text-reveal">
                To be a trusted semiconductor engineering organization,
                recognized for enabling reliable silicon through technical
                excellence, disciplined execution, and enduring customer
                relationships. We aspire to contribute meaningfully to the
                advancement of the global semiconductor ecosystem by
                continuously strengthening engineering capabilities,
                embracing evolving technologies, and delivering dependable
                value across every engagement.
              </p>

              <div className="vision-features">
                {visionPoints.map((point) => (
                  <div className="vision-feature" key={point.title}>
                    <div className="vision-feature-icon">
                      {point.icon}
                    </div>

                    <h3 className="vision-feature-title">
                      {point.title}
                    </h3>
                  </div>
                ))}
              </div>
            </div>

            <div className="vision-visual">
              <div className="vision-circle-main">
                <div className="vision-arc" />

                <span className="vision-orbit-dot dot-one" />
                <span className="vision-orbit-dot dot-two" />
                <span className="vision-orbit-dot dot-three" />

                <div className="vision-image-wrap">
                  <img
                    className="vision-image"
                    src={visionImage}
                    alt="Semiconductor engineering and silicon innovation"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Vision;